class HomeTestimonialsComponent {
	constructor() {
		this.sliderSelector = '.home-testimonial-slider .jet-listing-grid__items';
	}

	initialize() {
		jQuery(document).ready(($) => {
			setTimeout(() => {
				this.createNavigationButtons($);
				const slider = $(this.sliderSelector);

				if (slider.length && slider.hasClass('slick-initialized') && typeof slider.slick === 'function') {
					this.initSliderNav($, slider);
				} else {
					const waitForSlick = setInterval(() => {
						if (slider.length && slider.hasClass('slick-initialized') && typeof slider.slick === 'function') {
							clearInterval(waitForSlick);
							this.initSliderNav($, slider);
						}
					}, 200);
				}
			}, 1000);
		});
	}

	createNavigationButtons($) {
		$('.nav-icons-wrapper').empty();

		const uniqueIcons = [];
		$('.jet-listing-grid .slick-slide:not(.slick-cloned)').each(function (index) {
			const icon = $(this).find('img').attr('src');
			if (icon && !uniqueIcons.includes(icon)) {
				uniqueIcons.push(icon);
				$('.nav-icons-wrapper').append(`
					<div class="nav-icon" data-slide="${index}">
						<img src="${icon}" alt="icon" />
					</div>
				`);
			}
		});

		$('.nav-icon').eq(0).addClass('active');
	}

	initSliderNav($, slider) {
		$(document).on('click', '.nav-icon', (e) => {
			const slideIndex = $(e.currentTarget).data('slide');
			slider.slick('slickGoTo', slideIndex);
		});

		slider.on('afterChange', (event, slick, currentSlide) => {
			this.updateActive(currentSlide, $);
		});

		this.updateActive(0, $);
	}

	updateActive(currentSlide, $) {
		const icons = $('.nav-icon');
		const center = Math.floor(icons.length / 2);

		icons.removeClass('active');
		icons.each(function (index) {
			const order = (index - currentSlide + center + icons.length) % icons.length;
			$(this).css('order', order);
		});
		icons.eq(currentSlide).addClass('active');
	}
}

export { HomeTestimonialsComponent };
